import { useForm } from "react-hook-form";
import { UsecontactUsMutation } from "../../actions/homeActions";
import { useUser } from "../../actions/authActions";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
export default () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState(null);
  const userId = localStorage.getItem("userId");
  const { data: user, isLoading } = useUser(userId);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onSubmit", // Only validate on submit
    defaultValues: {
      full_name: "",
      email: "",
      mobile_num: "",
      description: "",
    },
  });

  // Watch email and phone fields for conditional validation
  const emailValue = watch("email");
  const phoneValue = watch("mobile_num");
  useEffect(() => {
    if (!isLoading && user && Object.keys(user).length > 0) {
      // Properly construct full name, handling undefined values
      const firstName = user?.first_name || user?.name || "";
      const lastName = user?.last_name || "";
      const fullName = `${firstName} ${lastName}`.trim();
      
      setValue("full_name", fullName);
      setValue("email", user?.email || "");
      setValue("mobile_num", user?.mobile_num || "");
    }
  }, [user, isLoading, setValue]);

  // Clear conditional errors when user fills either email or phone
  useEffect(() => {
    const hasEmail = emailValue && emailValue.trim() !== "";
    const hasPhone = phoneValue && phoneValue.trim() !== "";
    
    if (hasEmail || hasPhone) {
      clearErrors("email");
      clearErrors("mobile_num");
    }
  }, [emailValue, phoneValue, clearErrors]);

  // Debug: Log errors when they change
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
    }
  }, [errors]);
  const mutation = UsecontactUsMutation(navigate, setLoading);

  const customSubmitHandler = (e) => {
    e.preventDefault();
    
    // Get current form values
    const fullName = watch("full_name");
    const email = watch("email");
    const phone = watch("mobile_num");
    const description = watch("description");
    
    
    // Clear all previous errors
    clearErrors();
    
    let hasErrors = false;
    
    // Validate full name
    if (!fullName || fullName.trim() === "") {
      setError("full_name", {
        type: "manual",
        message: "Full Name is required",
      });
      hasErrors = true;
    }
    
    // Validate description
    if (!description || description.trim() === "") {
      setError("description", {
        type: "manual",
        message: "Description is required",
      });
      hasErrors = true;
    }
    
    // Validate email/phone (at least one required)
    const hasEmail = email && email.trim() !== "";
    const hasPhone = phone && phone.trim() !== "";
    
    if (!hasEmail && !hasPhone) {
      setError("email", {
        type: "manual",
        message: "Either Email or Phone Number is required",
      });
      setError("mobile_num", {
        type: "manual",
        message: "Either Email or Phone Number is required",
      });
      hasErrors = true;
    }
    
    // Validate email format if provided
    if (hasEmail && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("email", {
        type: "manual",
        message: "Please enter a valid email address",
      });
      hasErrors = true;
    }
    
    // If there are errors, stop here
    if (hasErrors) {
      return;
    }
    
    // Submit the form
    setLoading(true);
    mutation.mutate({
      full_name: fullName,
      email: email || "",
      phone: phone || "",
      description: description,
    });
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    
    // Trim values to check if they're actually empty
    const hasEmail = data.email && data.email.trim() !== "";
    const hasPhone = data.mobile_num && data.mobile_num.trim() !== "";
    
    
    // Check if at least one of email or phone is provided
    if (!hasEmail && !hasPhone) {
      setError("email", {
        type: "manual",
        message: "Either Email or Phone Number is required",
      });
      setError("mobile_num", {
        type: "manual",
        message: "Either Email or Phone Number is required",
      });
      return;
    }
    
    // Clear any previous conditional errors
    clearErrors("email");
    clearErrors("mobile_num");
    
    setLoading(true);
    mutation.mutate({
      full_name: data.full_name,
      email: data.email || "",
      phone: data.mobile_num || "",
      description: data.description,
    });
  };
  return {
    handleSubmit,
    onSubmit,
    customSubmitHandler,
    control,
    register,
    setValue,
    loading,
    setCountryCode,
    errors,
    user,
    watch,
  };
};